import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, StatBadge } from "@/components/admin/AdminLayout";
import { toast } from "sonner";
import { Star, EyeOff, Eye, Flag, Trash2 } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function Reviews() {
  const { t, lang } = useLang();
  const [reviews, setReviews] = useState([]);
  const locale = lang.toLowerCase() === "pt" ? "pt-PT" : lang.toLowerCase();
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (r, key) => {
    try { await api.patch(`/admin/reviews/${r.id}`, { [key]: !r[key] }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (r) => {
    if (!window.confirm(t("reviews_delete_confirm"))) return;
    await api.delete(`/admin/reviews/${r.id}`); load();
  };
  return (
    <div className="p-10 max-w-[1400px]">
      <PageHeader eyebrow={t("reviews_moderation")} title={t("reviews_title")} description="Client → driver and driver → client ratings." />
      <div className="border border-slate-200 bg-white">
        {reviews.length === 0 && <div className="p-16 text-center text-slate-500">—</div>}
        {reviews.map((r) => (
          <div key={r.id} className="border-b border-slate-200 p-6 flex gap-6">
            <div className="flex flex-col items-center min-w-[80px]">
              <div className="font-display text-3xl text-[#f59e0b]">{r.stars}</div>
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className={`w-3 h-3 ${i < r.stars ? "text-[#f59e0b] fill-[#f59e0b]" : "text-slate-300"}`} />
                ))}
              </div>
              <div className="text-[10px] text-slate-500 mt-2 uppercase">{r.reviewer_role}</div>
            </div>
            <div className="flex-1">
              <p className="text-[#0a0f1e] text-sm">{r.comment || <span className="text-slate-500 italic">—</span>}</p>
              <div className="text-xs text-slate-500 mt-2 font-mono">{new Date(r.created_at).toLocaleString(locale)}</div>
            </div>
            <div className="flex flex-col gap-2 items-end">
              <div className="flex gap-2">
                {r.flagged && <StatBadge status="flagged" />}
                {!r.visible && <StatBadge status="hidden" />}
              </div>
              <div className="flex gap-2 mt-2">
                <button onClick={() => toggle(r, "visible")} className="text-xs text-slate-500 hover:text-[#0a0f1e] flex items-center gap-1">
                  {r.visible ? <><EyeOff className="w-3 h-3" /> {t("action_hide")}</> : <><Eye className="w-3 h-3" /> {t("action_show")}</>}
                </button>
                <button onClick={() => toggle(r, "flagged")} className="text-xs text-slate-500 hover:text-amber-400 flex items-center gap-1"><Flag className="w-3 h-3" /> Flag</button>
                <button onClick={() => remove(r)} className="text-xs text-slate-500 hover:text-red-400 flex items-center gap-1"><Trash2 className="w-3 h-3" /> {t("action_delete")}</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
